import { CheckoutSessionCriteria } from '@nemuru-eng/js-api-client';

import { CheckoutSessionStatusTag } from '@/components/shared/components/CheckoutSessionStatusTag';
import { Text } from '@/components/shared/components/Text';
import { ApplicationType } from '@/config/types';

interface StatusFieldColumnProps {
  applicationType: ApplicationType;
  flex?: number;
  headerTextId?: string;
}

export const statusFieldColumn = ({ applicationType, flex, headerTextId }: StatusFieldColumnProps) => {
  const fieldNameByApplicationType = (applicationType: ApplicationType) => {
    switch (applicationType) {
      case ApplicationType.ORDER:
        return 'status';
      case ApplicationType.CHECKOUT_SESSION:
        return 'checkout_session_status';
    }
  };

  return {
    flex: flex ?? 0.53,
    field: fieldNameByApplicationType(applicationType),
    headerName: <Text tId={headerTextId ?? 'STATUS'} />,
    renderCell: (rowData: { row: CheckoutSessionCriteria }) => (
      <div
        style={{
          minWidth: '120px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          whiteSpace: 'break-spaces',
          width: '100%',
        }}
      >
        <CheckoutSessionStatusTag status={rowData.row.status} applicationType={applicationType} />
      </div>
    ),
  };
};
